/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjUzOTk1IDIuODQzNTdMNS41MjkxNyAxMi44NzEyTDYuNDU3NjYgMTMuMjQyNkwxMC40Njg0IDMuMjE0OTNMOS41Mzk5NSAyLjg0MzU3Wk00LjQwMDA1IDUuNDAwMDJMMy42MDAwNSA0LjYwMDAyTDAuMzAwMDQ5IDguMDAwMDJMMy42MDAwNSAxMS40TDQuNDAwMDUgMTAuNkwxLjcwMDA1IDguMDAwMDJMNC40MDAwNSA1LjQwMDAyWk0xMS42IDUuNDAwMDJMMTIuNCA0LjYwMDAyTDE1LjcgOC4wMDAwMkwxMi40IDExLjRMMTEuNiAxMC42TDE0LjMgOC4wMDAwMkwxMS42IDUuNDAwMDJaIiBmaWxsPSJpbmhlcml0Ii8+";